import { combineReducers } from 'redux';

import { ArticleAction, MediaExportState } from '../types';
import { Reducer } from '../../../types';
import {
  setOpenModalExportMedia,
  setDataExportMedia,
} from '../actions';

type ReducerOf<T extends keyof MediaExportState> = Reducer<MediaExportState, ArticleAction, T>;

const open: ReducerOf<'open'> = (state = false, action) => {
  switch (action.type) {
    case setOpenModalExportMedia.type:
      return action.payload;

    default:
      return state;
  }
};

const media: ReducerOf<'media'> = (state = null, action) => {
  switch (action.type) {
    case setDataExportMedia.type:
      return action.payload;

    default:
      return state;
  }
};


export default combineReducers<MediaExportState>({
  open,
  media,
});
